import Badge from 'components/badge/badge';
import Tooltip from 'components/tooltips/Tooltips';

const count = (value) => value.toLocaleString('fr-FR');

// The highest count of a PME: the card writes « De 3 à 4 » for a grand compte
// from 5. A threshold that is not a whole number has no such count.
const pmeRange = ({ grand_compte: grandCompte, pme }) => {
  if (!Number.isInteger(grandCompte)) return `De ${count(pme)} à moins de ${count(grandCompte)}`;
  if (grandCompte - 1 <= pme) return `${count(pme)}`;
  return `De ${count(pme)} à ${count(grandCompte - 1)}`;
};

// The texts are in French here, not in the locales, as JBWEB-1442 asks.
const RULES = {
  grand_compte: ({ grand_compte: grandCompte }) => `${count(grandCompte)} missions en cours (ETP) ou plus`,
  pme: (thresholds) => `${pmeRange(thresholds)} missions en cours (ETP)`,
  tpe: ({ pme }) => `Moins de ${count(pme)} missions en cours (ETP)`,
};
const SOURCES = {
  etp: 'Calculée d’après ses missions en cours aujourd’hui.',
  manual: 'Choisie à la main sur sa fiche.',
};

/**
 * The lines of the tooltip of a class: its rule, from the thresholds of the
 * list's answer (`sizeThresholds`, null before it comes), then how the class
 * was decided (`sizeSource`).
 */
export const sizeTooltipLines = ({ size, sizeSource, thresholds }) =>
  [thresholds && RULES[size] ? RULES[size](thresholds) : null, SOURCES[sizeSource] ?? null].filter(Boolean);

/**
 * The badge of a company's class (« Grand compte », « PME », « TPE ») in the
 * list, with its tooltip.
 */
const CompanySizeBadge = ({ label, size, sizeSource, thresholds }) => {
  const lines = sizeTooltipLines({ size, sizeSource, thresholds });
  return (
    <Tooltip
      disabled={lines.length === 0}
      testId="company-size-tooltip"
      text={lines.map((line) => (
        <span key={line} className="block">
          {line}
        </span>
      ))}
    >
      <span className="inline-flex" tabIndex={lines.length ? 0 : undefined}>
        <Badge type="SECONDARY">{label}</Badge>
      </span>
    </Tooltip>
  );
};

export default CompanySizeBadge;
